import React, { createContext, useContext, useMemo } from 'react';
import { Categories } from './categories';
import { useTrackCalendlyEvent } from './useStandardTracking';
import { Helmet } from 'react-helmet';

export interface AnalyticsCategoryContextProps {
  category: Categories;
  sessionId: string | undefined;
}

const defaultAnalyticsCategoryContext = {
  category: Categories.GENERAL,
  sessionId: undefined,
};

export const AnalyticsCategoryContext =
  createContext<AnalyticsCategoryContextProps>(defaultAnalyticsCategoryContext);

interface AnalyticsProviderProps {
  children: React.ReactNode;
  category?: Categories;
  sessionId?: string;
}

export const AnalyticsCategoryProvider: React.FC<AnalyticsProviderProps> = ({
  children,
  category = Categories.GENERAL,
  sessionId,
}) => {
  useTrackCalendlyEvent(category);
  const context = useMemo(
    () => ({ category, sessionId }),
    [category, sessionId],
  );
  return (
    <>
      <Helmet>
        <meta name="analytics-category" content={category} />
      </Helmet>
      <AnalyticsCategoryContext.Provider value={context}>
        {children}
      </AnalyticsCategoryContext.Provider>
    </>
  );
};

export const useAnalyticsCategory = () => {
  const { category } = useContext(AnalyticsCategoryContext);
  return category;
};

export const useAnalyticsSessionId = () => {
  const { sessionId } = useContext(AnalyticsCategoryContext);
  return sessionId;
};
